const getIn = (obj, keys) =>
    (typeof keys === 'string' ? keys.split('.') : keys).reduce((r, key) => (r ? r[key] : undefined), obj);

export { getIn };
